<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-card>
<!--        <b-row>-->
<!--          <b-col>-->
<!--            <h5>{{ $t('views.timetable.show.header') }}</h5>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row>
          <b-col>
            <b-form-group :label="$t('views.timetable.show.showCalendars') + ':'">
              <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="idUserDatas"
                      :options="userDataOptions"
                      name="flavour-1"
                      size="md"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <Calendar :idUserData="idUserDatas"></Calendar>
        <!--<b-row>-->
          <!--<b-col>-->
            <!--<b-btn>{{ $t('views.timetable.show.showOtherUsers') }}</b-btn>-->
          <!--</b-col>-->
        <!--</b-row>-->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Loader from '../../Layout/Loader'
import Calendar from './components/Calendar/Calendar'
import VueCookie from 'vue-cookie'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'TimetableShow',
  components: {
    Loader,
    Calendar
  },
  data () {
    return {
      isLoading: true,
      idUserDatas: [],
      userDataOptions: []
    }
  },
  created () {
    this.idUserDatas.push(parseInt(VueCookie.get('userdata_id')))
    this.getUserDatas()
    this.isLoading = false
  },
  methods: {
    getUserDatas () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': [5, 4, 3, 8]
      }
      this.userDataOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          let data = response.data['hydra:member']
          let array = []
          let userOption = {}
          for (let i in data) {
            let text = ''
            if (parseInt(this.getIdLink(data[i]['@id'])) === parseInt(VueCookie.get('userdata_id'))) {
              text += this.$t('views.timetable.show.myCalendar')
              userOption.text = text
              userOption.value = this.getIdLink(data[i]['@id'])
            } else {
              text += data[i].name + ' ' + data[i].surname
              array.push({
                text: text,
                value: this.getIdLink(data[i]['@id'])
              })
            }
          }
          array.unshift(userOption)
          this.userDataOptions = array
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
